module.exports = __webpack_public_path__ + "static/media/gelaende_boe_blur2.5570aebb.png";